<template>
  <div class="head">
    <ul>
      <li v-for="menu in menuList" :key="menu.url">
        <a :href="menu.url" target="_blank">{{ menu.name }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'c-head',
  data() {
    // let domain = 'zlgx.com';
    // let hostname = location.hostname;
    // let home = 'gangxin';
    // let trade = 'trade';
    // let cenpur = 'ore';
    // let logistics = 'log';
    // let wms = 'wms';
    // let bid = 'bid';
    // let oa = 'oa';
    // let fin = 'fin';

    // switch (true) {
    //   case hostname.indexOf('stable-dev') !== -1:
    //     domain = 'stable-dev.bdfint.cn';
    //     cenpur = 'jc';
    //     break;
    //   case hostname.indexOf('stable-test') !== -1:
    //     domain = 'stable-test.bdfint.cn';
    //     cenpur = 'jc';
    //     break;
    //   case hostname.indexOf('dev') !== -1:
    //     domain = 'dev.bdfint.cn';
    //     break;
    //   case hostname.indexOf('test') !== -1:
    //     domain = 'test.bdfint.cn';
    //     break;
    //   default:
    //     domain = 'zlgx.com';
    //     trade = 'trade';
    //     cenpur = 'ore';
    //     logistics = 'log';
    //     home = 'www';
    //     break;
    // }
    setTimeout(() => {
      let menuLIst = JSON.parse(localStorage.getItem('WEB_INFO')).topBar || [];
      this.menuList = menuLIst;
    }, 500);
    return {
      menuList: [],
      // menuList: [
      //   {
      //     name: '官网',
      //     path: '/platform',
      //     code: 'zsteel',
      //     url: `//${home}.${domain}`
      //   },
      //   {
      //     name: '钢材',
      //     path: '/platform1',
      //     code: 'trade',
      //     url: `//${trade}.${domain}`
      //   },
      //   {
      //     name: '物流',
      //     path: '/platform3',
      //     code: 'logistics',
      //     url: `//${logistics}.${domain}`
      //   },
      //   {
      //     name: '仓储',
      //     path: '/platform4',
      //     url: `//${wms}.${domain}`
      //   },
      //   {
      //     name: '办公',
      //     path: '/platform6',
      //     code: 'oa',
      //     url: `//${oa}.${domain}`
      //   },
      //   {
      //     name: '招采',
      //     path: '/platform7',
      //     code: 'bid',
      //     url: `//${bid}.${domain}`
      //   }
      // ]
    };
  },
};
</script>
<style lang="scss" scoped>
@import './style.scss';
</style>
